export default "__VITE_ASSET__uAqJ1KOU__"